var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4514 38.6027C22.812 40.3025 24.1923 42.4321 24.9179 43.7217C25.8013 45.3978 26.1642 46.5296 26.8228 48.5488C27.2092 49.6609 27.5721 50.0001 28.3411 50.0001C29.1811 50.0001 29.5636 49.4322 29.8594 48.5488C30.4707 46.644 30.9479 45.1966 31.6932 43.8124C33.1642 41.1622 35.0257 38.8039 36.8358 36.5402C37.3327 35.9052 40.5074 32.1666 41.9351 29.2009C41.9351 29.2009 43.6782 25.9592 43.6782 21.4278C43.6782 17.1923 41.9548 14.2463 41.9548 14.2463L36.9699 15.5833L33.9333 23.5575L33.184 24.6459L33.0262 24.851L32.8211 25.0994L32.482 25.5056L31.9851 26.0026L29.2876 28.1992L22.5596 32.0956L21.4514 38.6027Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4946 28.6567C16.147 32.419 19.2981 35.7041 21.4513 38.6028L32.8487 25.0995C32.8487 25.0995 31.2396 27.2055 28.341 27.2055C25.0993 27.2055 22.4728 24.6223 22.4728 21.3609C22.4728 19.1169 23.8097 17.5789 23.8097 17.5789L16.08 19.6414L14.4946 28.6567Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9829 6.7019C36.7649 7.92445 40.0067 10.4839 41.9549 14.2699L32.8449 25.123C32.8449 25.123 34.1818 23.5613 34.1818 21.341C34.1818 18.0085 31.3739 15.4964 28.3372 15.4964C25.4583 15.4964 23.8059 17.5826 23.8059 17.5826V10.7363L32.9829 6.7019Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5769 11.4818C18.8406 8.78426 22.808 6 28.2897 6C30.9399 6 32.9552 6.70198 32.9552 6.70198L23.8057 17.5788H17.3262L16.5769 11.4818Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4947 28.6566C14.4947 28.6566 13 25.687 13 21.408C13 17.3539 14.5854 13.8164 16.6006 11.5054L23.8294 17.5984L14.4947 28.6566Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google-maps.e510d323d6db299bb000ceaa6914e777.svg";
export { ForwardRef as ReactComponent };